import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: '¿Sirve para regiones?',
    answer: 'Sí, el manual incluye estrategias para las cadenas nacionales y mayoristas con presencia en todo Chile.'
  }, {
    question: 'No sé usar Excel, ¿me sirve?',
    answer: 'Sí, las plantillas son intuitivas y la guía PDF contiene toda la información estratégica.'
  }, {
    question: '¿Tengo que comprar comida de mala calidad?',
    answer: 'No. El sistema se basa en encontrar la misma calidad (o superior) por un precio de ingeniería.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-16 px-4" data-id="element-58" data-mp="2zazyssrwte6y">
      <div className="max-w-3xl mx-auto" data-id="element-59" data-mp="2zbrltf7fy3lm">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-12 text-center" data-id="element-60" data-mp="1vqsyy291z5lj">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-61" data-mp="1rq0mz18sqmlk">
          {faqs.map((faq, index) => <div key={index} className="bg-[#f8fafc] rounded-lg overflow-hidden shadow-md" data-id="element-62" data-mp="25gcjrdgbt9j1" data-mpi={index}>
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-100 transition-colors" data-id="element-63" data-mp="20mrk7gz347hq">
                <h3 className="text-lg md:text-xl font-semibold text-[#1a2332] pr-4" data-id="element-64" data-mp="2ah05bjlscy5v">
                  {faq.question}
                </h3>
                <ChevronDownIcon className={`w-6 h-6 text-[#1a2332] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-65" data-mp="2jf3tyos2ib1w" />
              </button>

              <div className={`overflow-hidden transition-all duration-200 ${openIndex === index ? 'max-h-48' : 'max-h-0'}`} data-id="element-66" data-mp="p2vv50cmla0u">
                <div className="px-6 pb-6" data-id="element-67" data-mp="2u259mugri78s">
                  <p className="text-gray-700 leading-relaxed" data-id="element-68" data-mp="2u2x76atx6f1p">{faq.answer}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}